// Funcion simple para encriptar ID
export const encryptId = (id) => {
  try {
    if (!id) return '';
    // Convertir a base64
    let base64 = btoa(id);
    // Invertir la cadena
    let invertido = base64.split('').reverse().join('');
    // Reemplazar caracteres problematicos para URL
    return invertido.replace(/[+/=]/g, function(match) {
      if (match === '+') return '-';
      if (match === '/') return '_';
      return '';
    });
  } catch (error) {
    console.error('Error al encriptar:', error);
    return id;
  }
};

// Funcion simple para desencriptar ID
export const decryptId = (encryptedId) => {
  try {
    if (!encryptedId) return '';
    // Restaurar caracteres
    let restaurado = encryptedId.replace(/[-_]/g, function(match) {
      if (match === '-') return '+';
      if (match === '_') return '/';
      return match;
    });
    // Invertir la cadena
    let invertido = restaurado.split('').reverse().join('');
    // Decodificar base64
    return atob(invertido);
  } catch (error) {
    console.error('Error al desencriptar:', error);
    return encryptedId;
  }
};